import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

const titleStyles = xcss({
	font: 'font.heading.medium',
	fontWeight: 'font.weight.medium',
	color: 'color.text',
	paddingTop: 'space.075',
});

interface TitleProps {
	children?: React.ReactNode;
}

export const Title = ({ children }: TitleProps): React.JSX.Element => {
	return (
		<Box xcss={titleStyles} as="h2">
			{children}
		</Box>
	);
};
